<template>
  <form id="storeuser" method="post" @submit.prevent="validateAndSubmit">
    <div class="col">
      <customer-details-form
        :pay-in-terms="false"
        :customer-details="order.customerDetails"
        :store-user="true"
        @property-changed="e => $emit('CustomerDetailsPropertyChanged', e)"
      />
    </div>
    <div class="col">
      <customer-address-form
        :address="order.invoiceAddress"
        :store-user="true"
        @AddressPropertyChanged="e => $emit('AddressPropertyChanged', e)"
      />
    </div>
    <fieldset class="submit">
      <div class="form-row">
        <div class="form-column">
          <input
            :value="$t('registrationForm.next')"
            type="submit">
        </div>
      </div>
    </fieldset>

    <v-modal
      v-if="showGenericErrorModal"
      :modal-id="'flashMessage'"
      :modal-class="'confirm-modal'"
      :title-id="'flashMessageTitle'"
      @close="showGenericErrorModal = false">
      <h2 id="flashMessageTitle">{{ $t('registrationForm.genericErrorModalTitle') }}</h2>
      <p class="error" v-html="$t('registrationForm.genericErrorModalContent')"/>
    </v-modal>
    <v-modal
      v-if="showChoosePaymentTypeModal"
      :modal-id="'flashMessagePaymentType'"
      :modal-class="'confirm-modal'"
      :title-id="'flashMessageTitlePaymentType'"
      @close="showChoosePaymentTypeModal = false">
      <h2 id="flashMessageTitleChoosePayment">{{ $t('registrationForm.choosePaymentTypeModalTitle') }}</h2>
      <p class="error" v-html="$t('registrationForm.choosePaymentTypeModalContent')"/>
    </v-modal>
  </form>
</template>

<style scoped>
  #store-user-form-container > form > div.col {
    width: 50%;
    padding-left: 1.5625rem;
  }
</style>

<script>
/* @flow */
import { mapState } from 'vuex'
import CustomerDetailsForm from './CustomerDetailsForm'
import CustomerAddressForm from './CustomerAddressForm'
import CustomerCreateAccountForm from './CustomerCreateAccountForm'
import VModal from '../components/modals/Modal'
import { ORDER_VALIDATION_STAGE_CUSTOMER_DETAILS } from '../order-api/order-api-client-constants'
import FocusMixin from '../mixins/focus'

export default {
  name: 'StoreUserCustomerForm',
  components: {
    CustomerDetailsForm,
    CustomerAddressForm,
    CustomerCreateAccountForm,
    VModal
  },
  mixins: [FocusMixin],
  props: {
    order: {
      type: Object,
      required: true
    },
    mustPaymentTypeBeSelected: {
      type: Boolean,
      required: true
    },
    isPaymentTypeSelected: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      showGenericErrorModal: false,
      showChoosePaymentTypeModal: false,
      useCustomerDetailsEmailAddressForRegistration: true,
      isValidating: false
    }
  },
  computed: {
    ...mapState({
      hasValidationErrors: state => (
        (state.cart.orderValidationErrors || []).length + (state.user.userValidationErrors || []).length) > 0
    })
  },
  watch: {
    isValidating: function (isValidating, wasValidating) {
      if (wasValidating && !isValidating && this.hasValidationErrors) {
        this.startScrollIntoView()
      }
    }
  },
  methods: {
    validate: async function () {
      if (this.mustPaymentTypeBeSelected && !this.assertPaymentTypeSelected()) {
        return false
      }
      this.isValidating = true
      try {
        await this.validateOrder()
      } catch (error) {
        console.log(error)
        this.isValidating = false
        this.showGenericErrorModal = true

        return false
      }
      this.isValidating = false

      return this.$store.state.cart.orderValidationErrors.length === 0 &&
        this.$store.state.registration.registrationValidationErrors.length === 0
    },
    validateOrder: async function () {
      return this.$store.dispatch('cart/validateOrder', {
        order: this.order,
        stage: ORDER_VALIDATION_STAGE_CUSTOMER_DETAILS
      })
    },
    submit: async function () {
      this.$router.push({ name: 'PaymentSelection', params: { lang: this.$route.params.lang } }).catch(() => {})
    },
    validateAndSubmit: async function () {
      if (!await this.validate()) {
        return false
      }
      await this.submit()
    },
    assertPaymentTypeSelected: function () {
      if (!this.isPaymentTypeSelected) {
        this.showChoosePaymentTypeModal = true
        return false
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/StoreUserCustomerForm.vue